import { render, staticRenderFns } from "./CheckoutPaymentCash.vue?vue&type=template&id=ef38c1cc&scoped=true&"
import script from "./CheckoutPaymentCash.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef38c1cc",
  null
  
)

export default component.exports